import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { UserRetrieveInterface } from "../../../middleware/interfaces/user/user-retrieve-interface";

export const UserRetrieve = {
  Retrieve: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const userRetrieveData: UserRetrieveInterface = state.data;
      const url = "./php/user/user-retriever-proxy.php";
      await axios
        .post(url, userRetrieveData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = "SOMETHING WENT WRONG! PLEASE CONTACT ADMIN.";
    }

    return serverResponse;
  },
};
